import debug from 'debug';
import axios from 'axios';
import * as qs from 'qs';
import jsonp from './jsonp';
import { requestHandler } from './utils';
import { Method } from './request';
import { requestInterceptor } from './apiInterceptor';
const sendJSONP = (request, getLatestRequestID) => {
    const req = requestInterceptor(request);
    const query = qs.stringify(req.body, { addQueryPrefix: true });
    const url = `${req.url}${query}`;
    return new Promise((resolve, reject) => {
        debug('sdk:api:jsonp')('url: ', url);
        debug('sdk:api:jsonp')('options: ', req.options);
        jsonp(url, req.options, (err, data) => {
            if (getLatestRequestID() !== req.id)
                return;
            if (err) {
                reject(err);
            }
            else if (typeof data === 'object' && !(data instanceof Array)) {
                resolve(data);
            }
            else {
                resolve(undefined);
            }
        });
    });
};
const sendPOST = (request) => new Promise((resolve, reject) => {
    const req = requestInterceptor(request);
    const headers = {
        'Content-type': 'application/json',
    };
    debug('sdk:api:post')('url: ', req.url);
    debug('sdk:api:post')('body: ', req.body);
    debug('sdk:api:post')('headers: ', headers);
    axios
        .post(req.url, req.body, { headers })
        .then((response) => {
        debug('sdk:api:post')('response: ', response);
        resolve(response.data);
    })
        .catch((err) => reject(err));
});
/**
 * Send a request to Findify JSON API.
 * @param req Request parameters.
 */
const request = {
    [Method.POST]: sendPOST,
    [Method.JSONP]: sendJSONP,
};
/**
 * Send a request to Findify JSON API.
 * @param req Request parameters.
 */
export const send = (req, getLatestRequestID) => {
    return requestHandler(() => request[req.method](req, getLatestRequestID), req.url);
};
